import { searchDaaqList } from "@/store/services/configuration/DaaqService";
import { Module } from "vuex";
import { NetworkState} from "@/types";
import { createNetwork, getNetworkNodeListByNetwork, searchPartyNetworkNodeList, deleteNetworknode } from "@/store/services/configuration/NetworkService";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";


const NetworkModule: Module<NetworkState, unknown> = {
  namespaced: true,
  state: {
  },
  getters: {
   
  },
  actions: {
    networkNodeList({ commit }, payload) {
        console.log("NetworkModule")
        const { filter, callback } = payload;
        getNetworkNodeListByNetwork(filter)
          .then((res) => {
            callback(res);
          })
          .catch((e) => console.error(e));
    },
    searchPartyNetworkNodeList({ commit }, payload) {
        const { filter,offset,limit, callback } = payload;
        searchPartyNetworkNodeList(filter,offset,limit)
          .then((res) => {
            callback(res);
          })
          .catch((e) => console.error(e));
      },

      createNetwork({ commit }, payload) {
        const { networkPayload, callback } = payload;
        createNetwork(networkPayload)
          .then((res: any) => {
            callback(res);
          })
          .catch((e: any) => console.error(e));
      },
      deleteNetworknode({ commit }, payload) {
        const { resourceUid } = payload
        deleteNetworknode(resourceUid)
          .then((res:any) => {
            Notify.create({
              message: i18n.global.t("order.messages.deleteNetworknodeSucc"),
              color: "positive",
              })
                    
            })
          .catch((err:any) => {
            console.error(err);
              Notify.create({
                message: "Error",
                color: "negative",
              });
            })
        },
  },
  mutations: {

  },
};

export default NetworkModule;
